import { useState, useEffect } from "react";
import LanguageSelectBanner from "./LanguageSelectBanner";
import TextArea from "./TextArea";
import { AudioProvider } from "../contexts/Audio";
import School from "./School";
import Instructions from "./Instructions";

const Provider = () => {
    const [selectedLanguage, setSelectedLanguage] = useState("de");
    const [text, setText] = useState("");

    // Read URL parameters on mount
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const lang = params.get("lang"); // de-DE; en-GB; fr-FR
        const prefill = params.get("text");

        if (lang) setSelectedLanguage(lang);
        if (prefill) setText(prefill);
    }, []);

    return (
        <>
            <AudioProvider>
                <LanguageSelectBanner
                    selectedLanguage={selectedLanguage}
                    setSelectedLanguage={setSelectedLanguage}
                />
                <TextArea text={text} setText={setText} selectedLanguage={selectedLanguage} />
            </AudioProvider>
            <div className="h-10" />

            <Instructions />
            <div className="h-10" />
            <School />
        </>
    );
};

export default Provider;
